import { useMemo } from "react";
import s from './index.module.css';
import { useGetGroup } from "@/hooks/useGetGroup";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import useRoles from "@/hooks/useRoles";

export const GroupSelection = ({state, setFieldInState}) => {
    const { isSeminarian, isSeniorSeminarian } = useRoles();

    const filter = useMemo(
        () => {
          const filters = [
            `[direction_id][eq]=${state.direction_id}`,
          ]
          return filters;
        },
        [state.direction_id]
    );

    const groups = useGetGroup(
        (isSeminarian || isSeniorSeminarian),
        { filter },
        ({ direction_id }) => direction_id === state.direction_id,
        state.direction_id ? true : false
    );

      const fieldsGroups = {
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: true,
        onChange: e => setFieldInState({field: 'group_id', value: e, resetFields: [] }),
        options: !state.direction_id ? [] : groups.select,
        value: state.group_id,
        placeholder: 'Выберите группы',
        notFoundContent: !state.direction_id ? 'Сначала выберите курс' : 'Группы не найдены'
    };

    return (
        <Select 
            fields={fieldsGroups} 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
        />
    );
}